export const PENSIONACQUISITIONTYPE = {
    EQUALACQUISITION: 'JA',
    AGERELATEDACQUISITION: 'AT',
};
